import { z } from "zod";
import { ContactStatus, LeadSource, PreferredContactMethod } from "../api/crmApi";

export const contactSchema = z.object({
    name: z.string().min(1, "Name is required"),
    email: z.string().min(1, "Email is required").email("Valid email address required"),
    phone: z.string().max(30, "Phone must be 30 characters or less").optional(),
    mobile: z.string().max(30, "Mobile must be 30 characters or less").optional(),
    jobTitle: z.string().optional(),
    department: z.string().max(120, "Department must be 120 characters or less").optional(),
    linkedinUrl: z.string().url("Please enter a valid URL").optional().or(z.literal("")),
    companyId: z.string().min(1, "Company is required"),
    assignedTo: z.string().min(1, "Assignee is required"),
    status: z.nativeEnum(ContactStatus).optional(),
    leadSource: z.nativeEnum(LeadSource).optional(),
    preferredContactMethod: z.nativeEnum(PreferredContactMethod).optional(),
    isPrimary: z.boolean().optional(),
    doNotContact: z.boolean().optional(),
});

export type ContactFormValues = z.infer<typeof contactSchema>;
